import { computed, getCurrentInstance } from 'vue';
import { useUIStore } from '@/store/uiStore';
import { useUserStore } from '@/store/userStore';
import { isDealEmailEnabled } from '@/services/dealEmailService';
import DealEmailReplyModal from '@/components/deals/DealEmailReplyModal.vue';

/**
 * Compose an email to a customer. Uses CRM mail (logged on the deal, replies land in the
 * CRM inbox) when enabled and a deal is known; otherwise falls back to the mail client.
 */
export function useCustomerEmail() {
  const instance = getCurrentInstance();
  const $t = instance.appContext.config.globalProperties.$t;
  const uiStore = useUIStore();
  const userStore = useUserStore();

  const crmEmailEnabled = computed(() => isDealEmailEnabled(userStore.currentOrganization));

  const composeEmail = ({ dealId = null, email = null, onSent = null } = {}) => {
    if (crmEmailEnabled.value && dealId) {
      uiStore.addModal(DealEmailReplyModal, {
        title: $t('deals.mail_compose'),
        size: 'md',
        dealId,
        recipient: email,
        onSent,
      });
      return;
    }
    if (email) {
      window.location.href = `mailto:${email}`;
    }
  };

  return { crmEmailEnabled, composeEmail };
}
